import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { IotnetMapPopover } from "../iotnet-map-popover/iotnet-map-popover";

@Component({
  selector: "iotnet-map-info",
  templateUrl: "iotnet-map-info.html",
  styleUrls: ["./iotnet-map-info.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IotnetMapPopover, TranslatePipe],
})
export class IotnetMapInfo {}
